import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import HeaderControls from "../../components/header-controls/HeaderControls";
import DirectoryButtonArea from "../../components/directory-button-area/DirectoryButtonArea";
import SearchBar from "../../components/search-bar/SearchBar";
import SecondaryControls from "../../components/secondary-controls/SecondaryControls";
import DirectoryCardArea from "../../components/directory-card-area/DirectoryCardArea";
import DirectoryList from "../../components/directory-list/DirectoryList";
import { IPlan } from "../../interfaces/IPlan";
import axios from "axios";
import { DownloadIcon } from "../../components/icons/Icons";
import DownloadButton from "../../components/download-button/DownloadButton";
import { IAppContext } from "../../context/DefaultAppState";
import _ from "lodash";
import { Link } from "react-router-dom";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const DownloadPage = (props: any) => {
  const appContext = useContext(AppContext);
  //console.log(`${baseURL}`)

  const { planCode } = props.match.params;

  useEffect(() => {
    initializeResults(planCode, appContext);
    /* if (!appContext.plansData.length) return;
    const first = appContext.plansData[0];
    const plans = appContext.plansData?.filter((p: any) => p.NavitusPharmacy === '');
    console.log('First:', first);
    console.log(plans.length);
    console.log(appContext.plansData.length);
    if (plans.length) {
      setSitePlans(plans);
    } else {
      setSitePlans([first])
    } */
  }, []);

  /* useEffect(() => {
    if (!appContext.plansData.length) return;
    const first = appContext.plansData[0];
    const plans = appContext.plansData;
    const filteredPlans = plans.filter((p: any) => p.navitusPharmacy !== '');
    console.log('First:', first);
    console.log(plans.length);
    console.log(filteredPlans.length);
    console.log(appContext.plansData.length);
    if (filteredPlans.length < 2) {
      setSitePlans([first]);
    } else {
      setSitePlans(filteredPlans)
    }
  }, []); */

  return (
    <>
      <div className="header-container">
        <div className="header-message">
          <HeaderControls />
          <DirectoryButtonArea />
          <div className="select-mini-bg">
            <SearchBar />
          </div>
          <></>
        </div>
      </div>
      <div className="body-container">
        <h3 className="download-message">Please select which Plan's Pharmacy Directory file you would like to download. </h3>
        <div >
          {appContext.sitePlans.length < 3 ? appContext.sitePlans.map( (plan: IPlan) => (
            <>
              <DownloadButton buttonText={`2023 ${plan.shortPlanName} Provider and Pharmacy Directory w/ Preamble - English`} handleClick={() => handleData(plan, 'English')}>
                <DownloadIcon/>
              </DownloadButton>
              <DownloadButton buttonText={`2023 ${plan.shortPlanName} Provider and Pharmacy Directory w/ Preamble - Spanish`} handleClick={() => handleData(plan, 'Spanish')}>
                <DownloadIcon/>
              </DownloadButton>
            </>
          )) : appContext.sitePlans.map( (plan: IPlan) => (
            <>
              <DownloadButton buttonText={`2023 ${plan.planName} Provider and Pharmacy Directory (${plan.stateAbbreviation}) w/ Preamble - English`} handleClick={() => handleData(plan, 'English')}>
                <DownloadIcon/>
              </DownloadButton>
              <DownloadButton buttonText={`2023 ${plan.shortPlanName} Provider and Pharmacy Directory (${plan.stateAbbreviation}) w/ Preamble - Spanish`} handleClick={() => handleData(plan, 'Spanish')}>
                <DownloadIcon/>
              </DownloadButton>
            </>))}
        </div>
      </div>
    </>
  );
};

const handleData = (plan: IPlan, language: string) => {
  (async () => {
    /* const { data } = await axios.get(`/Pharmacies/Print`, {
      params: {
        key: plan?.contractId,
        id: plan?.id,
        language: language
      }
    }); */
    //console.log(baseURL);
    const linkSource = baseURL + `Pharmacies/Print?key=${plan?.contractId}&id=${plan?.id}&language=${language}`;
    console.log(linkSource);
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('id', 'temp-anchor');
    const fileName = `${plan?.planName} Pharmacy Directory - ${plan?.stateAbbreviation} - ${language}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.target = '_blank';
    downloadLink.style.display = 'none';
    downloadLink.click();
    downloadLink.remove();
  })();
};

const initializeResults = (
  planCode: string | null,
  appContext: IAppContext
) => {
  let apiRoute = '';
  
  (async () => {
    try {
      const { data } = await axios.get(`/Plans`, {
        params: {
          
        }
      });
      const originalLength = data.length;
      const fullData = data;

      const planUrl = window.location.host;
      //const planUrl = 'alignseniorcare.com';
      //const planUrl = 'nhcadvantageplan.com';

      const plans = fullData?.filter((p: any) => p.planSite === planUrl);
      console.log(window.location.host);
      const nav = plans.map((plan: any) => plan.navitusPharmacy);
      console.log(nav);
      if(plans) {
        const plan = plans[0];
        document.documentElement.setAttribute('theme', plan.styleTheme);
        appContext.updatePlanName(plan.name);
        appContext.updatePlansData(plans);
        
        const fullPlans = plans.map((plan: any) => plan);
        const detailedPlans = plans?.filter((p: any) => p.navitusPharmacy !== "");
        
        console.log('First:', plan);
        console.log(detailedPlans.length);
        console.log(fullPlans.length);
        if (detailedPlans.length === 0) {
          appContext.updateSitePlans([fullPlans[0]]);
        } else {
          appContext.updateSitePlans(detailedPlans);
        }
      }
    } catch (err) {
      console.error(err);
    };

    rebuildContext(planCode, appContext);
    //setStateMethod(results);
  })();
};

const rebuildContext = (planCode: string | null, appContext: IAppContext) => {
  if (planCode) {
    const currentPlan = appContext.plansData.find(p => p.contractId === planCode);

    if(currentPlan) {
      appContext.updatePlanCode(planCode);
      appContext.updatePlan(currentPlan);
      appContext.updatePlanName(currentPlan.planName);
      appContext.updateDisclaimerUrl(currentPlan.ipdDisclaimerLink);
      appContext.updatePlanState(currentPlan.state);
    }
  }
};

export default DownloadPage;